import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getFirstFocusable } from 'src/scripts/utilities/focusableElementUtils';
import api from '@utils/api';
import classNames from 'classnames';
import { getStep } from '@state/features/accordion.selectors';
import { AccordionStepsActionTypes, ConnectivityActionTypes } from '@state/features/common.types';
import { Form } from 'react-final-form';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import FormField from '@ui/formfield/FormField';
import Loading from '@ui/loading/Loading';
import formutils from '@utils/formutils';
import urlUtils from '@utils/urlUtils';
import useBreakpoint from '@utils/useBreakpoint';
const addressfields = ['paymentMethod', 'email', 'iban'];
const ConnectivityCheckoutStepPayment = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { product, paymentData, registry, chosenPaymentMethod } = useSelector((state) => state.connectivity);
    const step = useSelector(getStep) || 'personalData';
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const currentBreakpoint = useBreakpoint();
    const paymentFormRef = useRef(null);
    useEffect(() => {
        if (!registry) {
            dispatch({ type: AccordionStepsActionTypes.NAVIGATE_STEP, payload: 'personalData' });
        }
    }, []);
    useEffect(() => {
        let val = {};
        if (paymentData && paymentData.paymentMethods && paymentData.paymentMethods.length > 0) {
            api.getForm('connectivityPayment', val).then((data) => {
                let selectedPaymentMethod = chosenPaymentMethod;
                if (!selectedPaymentMethod) {
                    selectedPaymentMethod = paymentData.paymentMethods[0].ID;
                }
                val.paymentMethod = selectedPaymentMethod;
                if (paymentData.iban) {
                    val.iban = paymentData.iban;
                }
                val.email = registry.email;
                dispatch({ type: ConnectivityActionTypes.UPDATE_PAYMENTMETHOD, payload: selectedPaymentMethod });
                setInitialValues(val);
                setFormdef(data);
            });
        }
    }, [paymentData]);
    const onSubmit = async (values) => {
        if (!chosenPaymentMethod) {
            return;
        }
        props.setErrors([]);
        urlUtils.removeErrorParamCheckout(step);
        let err = await validate(values);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        return api
            .connectivitySubmitPayment(values, formdef)
            .then((data) => {
            if (!formutils.checkValidationAfterSubmit(data, err)) {
                return err;
            }
            if (data.serverErrors && data.serverErrors.length > 0) {
                props.setErrors(data.serverErrors);
                return;
            }
            if (data.error) {
                if (data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                    return;
                }
                props.setErrors(['unknown error']); // temp
                return;
            }
            dispatch({ type: ConnectivityActionTypes.UPDATE_PAYMENTDATA, payload: data.paymentData });
            dispatch({ type: AccordionStepsActionTypes.NAVIGATE_STEP, payload: 'review' });
        })
            .catch((e) => props.setErrors([e]));
    };
    const validate = async (values) => {
        let errors = await formutils.validateForm(values, formdef, 'connectivityPayment');
        if (chosenPaymentMethod === 'CC') {
            if (values.email) {
                if (!/^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/.test(values.email)) {
                    errors.email = t('invalid.email');
                }
            }
            else {
                errors.email = t('required.field');
            }
            if (!values.creditCardAuthorize) {
                errors.creditCardAuthorize = t('required.field');
            }
        }
        else if (chosenPaymentMethod === 'SDD') {
            if (values.iban) {
                if (!/([a-zA-Z]{2})\w+/.test(values.iban)) {
                    errors.iban = t('invalid.iban');
                }
            }
            else {
                errors.iban = t('required.field');
            }
            if (!values.sddAuthorize) {
                errors.sddAuthorize = t('required.field');
            }
        }
        return errors;
    };
    const selectPaymentMethod = (event, setValue, values) => {
        props.setErrors([]);
        event.target.focus();
        dispatch({ type: ConnectivityActionTypes.UPDATE_PAYMENTMETHOD, payload: event.target.value });
    };
    const printPayments = (form, values) => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "paymentmethods" },
                React.createElement(FormField, { label: "", name: "paymentMethod", type: "radio", groupClassName: "boxed-radio", onChange: (e) => selectPaymentMethod(e, form.mutators.setValue, values), options: []
                        .concat(paymentData.paymentMethods)
                        .map((method) => {
                        return printPaymentMethod(method, values);
                    }) }))));
    };
    const printPaymentMethod = (method, values) => {
        return {
            value: method.ID,
            label: (React.createElement("span", { key: method.name, className: classNames('radio-payment') },
                React.createElement("p", { className: 'payment-name' }, method.name),
                method.ID === 'CC' && paymentData.paymentCards && paymentData.paymentCards.length > 0 && (React.createElement("span", { className: classNames('accepted-payments', { 'hide': isMobile && (chosenPaymentMethod !== method.ID) }) }, paymentData.paymentCards.map((card, i) => {
                    return (React.createElement("img", { src: card, alt: method.name, className: 'payment-icon', key: i, width: '42', height: '30' }));
                }))),
                chosenPaymentMethod === method.ID && (React.createElement("p", { className: 'info', dangerouslySetInnerHTML: { __html: method.description } })))),
            content: (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "component-container" },
                    React.createElement("div", { className: 'payment-method-container' },
                        method.ID === 'CC' && (React.createElement(React.Fragment, null,
                            React.createElement(DwFormField, { def: formdef, name: "email", placeholder: t('label.placeholder.email'), className: "visible", readonly: true, requiredLabel: true }),
                            React.createElement("div", { className: 'checkbox-authorize' },
                                React.createElement(DwFormField, { def: formdef, type: 'checkbox', name: "creditCardAuthorize", requiredLabel: true, mandatoryLabelEndPosition: true })),
                            React.createElement("p", { className: 'info-mandatory-label' }, t('label.info.mandatory')))),
                        method.ID === 'SDD' && (React.createElement(React.Fragment, null,
                            React.createElement(DwFormField, { def: formdef, name: "iban", placeholder: t('label.placeholder.iban'), className: "visible", requiredLabel: true }),
                            React.createElement("div", { className: 'checkbox-authorize' },
                                React.createElement(DwFormField, { def: formdef, type: 'checkbox', name: "sddAuthorize", requiredLabel: true, mandatoryLabelEndPosition: true })),
                            React.createElement("p", { className: 'info-mandatory-label' }, t('label.info.mandatory')))))))),
        };
    };
    if (!paymentData || !formdef) {
        return React.createElement(React.Fragment, null);
    }
    let isMobile = currentBreakpoint < window.mqObj.md;
    return (React.createElement("div", { className: "checkout-connectivity--payment" },
        React.createElement("div", { className: 'checkout-connectivity-payment' },
            React.createElement("p", { className: 'checkout-step-description' }, t('connectivity.checkout.payment.description')),
            React.createElement(Form, { onSubmit: onSubmit, initialValues: initialValues, validate: validate, mutators: {
                    global: formutils.globalMutator,
                    setValue: ([selected], state, { changeValue }) => {
                        addressfields.forEach((f) => {
                            changeValue(state, f, () => selected[f]);
                        });
                        // console.log('setValue ' + key + '=' + value);
                    },
                }, render: ({ handleSubmit, errors, form, submitting, pristine, values }) => (React.createElement("form", { id: 'payment-form', onSubmit: (e) => {
                        handleSubmit(e);
                        if (errors && Object.keys(errors).length > 0) {
                            setTimeout(() => {
                                var _a;
                                const invalidElements = (_a = paymentFormRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.is-invalid');
                                if ((invalidElements === null || invalidElements === void 0 ? void 0 : invalidElements.length) > 0) {
                                    invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    setTimeout(() => { var _a; return (_a = getFirstFocusable(invalidElements[0])) === null || _a === void 0 ? void 0 : _a.focus(); }, 500);
                                }
                            }, 150);
                        }
                    }, ref: paymentFormRef },
                    printPayments(form, values),
                    React.createElement("div", { className: 'checkout-navigations' },
                        React.createElement(Button, { type: "submit", cls: ['cta-primary'], isAnimated: true, style: { pointerEvents: submitting ? 'none' : 'initial', cursor: submitting ? 'not-allowed' : 'pointer' } },
                            submitting && React.createElement(Loading, { inline: true }),
                            React.createElement("span", { style: { opacity: submitting ? 0 : 1 } }, t('common.proceed')))))) }))));
};
export default ConnectivityCheckoutStepPayment;
